// extracted by mini-css-extract-plugin
export default {"empty":"styles_empty__j5EzQ","loading":"styles_loading__gSpTU"};